// Permission keys for each Settings sub-tab. Must match the backend
// catalog in `backend/routers/permissions.py` (the `settings_*` group).
//
// `key`     — tab identifier in the <Tabs value=...>
// `permKey` — backend permission module key (e.g. `settings_general`)
// `label`   — human-readable tab title (matches the visible text)
//
// To gate a tab, use `can(`${permKey}.view`)`. To enable saves/edits in
// it, use `can(`${permKey}.edit`)`. Superadmin bypass works automatically
// via the existing `usePermissions` hook.
export const SETTINGS_TABS = [
  { key: 'general',                permKey: 'settings_general',               label: 'General' },
  { key: 'users',                  permKey: 'settings_users',                 label: 'Users' },
  { key: 'roles',                  permKey: 'settings_roles',                 label: 'Roles & Permissions' },
  { key: 'profile-changes',        permKey: 'settings_profile_changes',       label: 'Profile Changes' },
  { key: 'project',                permKey: 'settings_project',               label: 'Project' },
  { key: 'certificates',           permKey: 'settings_certificates',          label: 'Certificates' },
  { key: 'expenses',               permKey: 'settings_expenses',              label: 'Expense Categories' },
  { key: 'training-templates',     permKey: 'settings_training_templates',    label: 'Training Templates' },
  { key: 'numbering',              permKey: 'settings_numbering',             label: 'Numbering' },
  { key: 'invoice-items',          permKey: 'settings_invoice_items',         label: 'Invoice Items' },
  { key: 'email',                  permKey: 'settings_email',                 label: 'Email' },
  { key: 'archived',               permKey: 'settings_archived',              label: 'Archived' },
  { key: 'doc-categories',         permKey: 'settings_doc_categories',        label: 'ISO Categories' },
  { key: 'checklist-templates',    permKey: 'settings_checklist_templates',   label: 'Checklists' },
  { key: 'test-report-templates',  permKey: 'settings_test_report_templates', label: 'Test Reports' },
  { key: 'task-templates',         permKey: 'settings_task_templates',        label: 'Tasks' },
  { key: 'backup',                 permKey: 'settings_backup',                label: 'Backup' },
  { key: 'reminders',              permKey: 'settings_reminders',             label: 'Reminders' },
  { key: 'translations',           permKey: 'settings_translations',          label: 'Translations' },
  { key: 'login-audit',            permKey: 'settings_login_audit',           label: 'Login Log' },
];

export const ALL_SETTINGS_VIEW_KEYS = SETTINGS_TABS.map((t) => `${t.permKey}.view`);
